import { ModelBase } from '../../core/models';
import { Role } from '../../directory/models';
import { Profile } from '../../directory/models/profile.model';

export class User extends ModelBase {
  role: Role;
  profile: Profile;
}
